/**
 * OMS MENU: five sections (owner, 2026-10-23 ~21:00 IST).
 * "Order processing ... Inventory ... Return ... Payments ... baki sab OMS Setting me."
 *
 * Every item reuses an existing route and an existing page permission key (`pageKey` in PAGE_REGISTRY),
 * so an item is visible to exactly the users who can already open that page. Items whose `id` equals
 * their `pageKey` are the page's own menu entry; the others are shortcuts (a tab of Marketplace
 * Operations, or a page that also lives in WMS / Reports / Settings).
 * `comingSoon` entries are shown on the section landing page only, never as links.
 */
import {
  ClipboardList, Printer, ListChecks, FileText, Truck, MapPin, BarChart3, ShoppingCart,
  Boxes, Database, Link2, Archive, PackageX, Package,
  RotateCcw, ScanBarcode, AlertTriangle, Clock, TrendingDown,
  IndianRupee, Scale, Receipt, Wallet,
  Settings, Users, Activity, CalendarClock, ListTodo, Monitor, ShieldCheck, Mail, FileSearch,
  Plug, Cog, UserCheck, Download,
} from "lucide-react";

export const MARKETPLACE_OPS_PATH = "/marketplace-operations";
const ops = (tab, extra = "") => `${MARKETPLACE_OPS_PATH}?tab=${tab}${extra}`;

export const OMS_SECTIONS = [
  {
    id: "orders",
    label: "Order Processing",
    path: "/oms/orders",
    icon: ClipboardList,
    hint: "Orders process karo, labels print karo, dispatch aur order reports dekho.",
    items: [
      { id: "order-processing", pageKey: "order-processing", path: "/order-processing", label: "Order Processing", icon: ClipboardList, hint: "Sab marketplace orders ek jagah: Pending se Delivered tak, filters ke saath." },
      { id: "oms-label-jobs", pageKey: "marketplace-label-jobs", path: "/marketplace-label-jobs", label: "Labels & Printing", icon: Printer, hint: "Marketplace labels download aur print jobs." },
      { id: "oms-picklists", pageKey: "picklist-list", path: "/picklist", label: "Picklists", icon: ListChecks, hint: "Aaj ke orders ki picklist banao aur track karo." },
      { id: "oms-manifests", pageKey: "marketplace-operations", path: ops("manifests"), label: "Manifests", icon: Truck, hint: "Marketplace manifests jo AGM ONE me aaye." },
      { id: "oms-tracking", pageKey: "marketplace-operations", path: ops("tracking"), label: "Tracking", icon: MapPin, hint: "Shipment tracking snapshots." },
      { id: "oms-documents", pageKey: "marketplace-operations", path: ops("documents"), label: "Documents", icon: FileText, hint: "Label / invoice documents ki processing." },
      { id: "oms-channel-dashboard", pageKey: "dashboard", path: "/channel-dashboard", label: "Channel Dashboard (Uniware)", icon: BarChart3, hint: "Channel-wise orders aur dispatch summary (Uniware data)." },
      { id: "oms-uniware-pending", pageKey: "unicommerce", path: "/unicommerce/reconciliation", label: "Uniware Pending Check", icon: ShoppingCart, hint: "Uniware ke pending orders ka milan." },
    ],
    comingSoon: [
      { id: "order-reports", label: "Order Reports", hint: "Marketplace / account, status, date aur SKU ke hisaab se, Excel export ke saath." },
    ],
  },
  {
    id: "inventory",
    label: "Inventory",
    path: "/oms/inventory",
    icon: Boxes,
    hint: "Channel listing, Master SKU, mapping aur stock: sab yahan.",
    items: [
      { id: "oms-channel-listing", pageKey: "marketplace-operations", path: ops("listings"), label: "Channel Listing", icon: ListTodo, hint: "Har marketplace account ki listings." },
      { id: "oms-master-sku", pageKey: "marketplace-operations", path: ops("master-sku"), label: "Master SKU", icon: Database, hint: "AGM ONE ke master SKU (style, color, size)." },
      { id: "oms-sku-mapping", pageKey: "marketplace-operations", path: ops("sku-mapping"), label: "SKU Mapping", icon: Link2, hint: "Channel SKU ko Master SKU se jodo aur review karo." },
      { id: "oms-inventory", pageKey: "marketplace-operations", path: ops("inventory"), label: "Inventory", icon: Package, hint: "Marketplace stock vs AGM ONE stock ka milan." },
      { id: "oms-stock-push", pageKey: "marketplace-operations", path: ops("inventory-push"), label: "Stock Out & Push", icon: PackageX, hint: "Stock Out / back in stock aur sab accounts pe push (dry run)." },
      { id: "oms-warehouse-stock", pageKey: "finished-inventory", path: "/finished-inventory", label: "Warehouse Stock", icon: Archive, hint: "Godown me tayyar maal ka stock." },
    ],
    comingSoon: [],
  },
  {
    id: "returns",
    label: "Returns",
    path: "/oms/returns",
    icon: RotateCcw,
    hint: "Marketplace returns, warehouse scan, aur jo return abhi tak nahi aaya.",
    items: [
      { id: "oms-marketplace-returns", pageKey: "marketplace-operations", path: ops("returns"), label: "Marketplace Returns", icon: RotateCcw, hint: "Marketplace se aaye returns / RTO, marketplace status aur WH scan ke saath." },
      { id: "oms-return-scan", pageKey: "return-scan", path: "/return-scan", label: "Warehouse Scanned Returns", icon: ScanBarcode, hint: "Warehouse me scan hue returns." },
      { id: "oms-return-not-received", pageKey: "marketplace-operations", path: ops("returns-not-in-wh"), label: "Delivered, WH me nahi aaya", icon: AlertTriangle, hint: "Marketplace bolta hai return delivered, par warehouse me scan nahi hua." },
      { id: "oms-returns-over-60-days", pageKey: "marketplace-operations", path: ops("returns-over-days"), label: "60+ din, delivered nahi", icon: Clock, hint: "60 din se purane returns jo marketplace ke hisaab se bhi delivered nahi hue." },
      { id: "oms-return-reports", pageKey: "return-analytics", path: "/return-analytics", label: "Return Reports", icon: TrendingDown, hint: "Daily, courier, channel, SKU-wise return reports." },
      { id: "oms-return-putaway", pageKey: "bulk-putaway", path: "/bulk-putaway", label: "Return Putaway", icon: Download, hint: "Scanned returns ka putaway export." },
    ],
    comingSoon: [],
  },
  {
    id: "payments",
    label: "Payments",
    path: "/oms/payments",
    icon: IndianRupee,
    hint: "Settled, unsettled aur payment reconciliation.",
    items: [
      { id: "oms-payments-settled", pageKey: "marketplace-operations", path: ops("payments"), label: "Settled Payments", icon: Wallet, hint: "Marketplace payouts ki lines jo AGM ONE me aa chuki hain." },
      { id: "oms-payments-reconciliation", pageKey: "marketplace-operations", path: ops("reconciliation"), label: "Reconciliation", icon: Scale, hint: "Marketplace vs AGM ONE ke mismatch." },
      { id: "oms-gst-reports", pageKey: "marketplace-operations", path: ops("gst-reports"), label: "GST Reports", icon: Receipt, hint: "Marketplace GST reports." },
    ],
    comingSoon: [
      { id: "payments-unsettled", label: "Unsettled Report", hint: "Delivered orders jinka payment abhi tak nahi aaya." },
      { id: "payments-settlement-reconciliation", label: "Settled vs Order reconciliation", hint: "Har order ka expected vs mila hua payment." },
    ],
  },
  {
    id: "settings",
    label: "OMS Settings",
    path: "/oms/settings",
    icon: Settings,
    hint: "Accounts, automation, schedules, sessions aur baaki settings.",
    items: [
      { id: "marketplace-operations", pageKey: "marketplace-operations", path: MARKETPLACE_OPS_PATH, label: "Marketplace Overview", icon: ShoppingCart, hint: "Sab marketplace accounts ka overview." },
      { id: "oms-accounts", pageKey: "marketplace-operations", path: ops("accounts"), label: "Accounts", icon: Users, hint: "Marketplace accounts / connections." },
      { id: "oms-sessions", pageKey: "marketplace-operations", path: ops("sessions"), label: "Sessions", icon: UserCheck, hint: "Login sessions ki health." },
      { id: "oms-agent-profiles", pageKey: "marketplace-operations", path: ops("agent-profiles"), label: "Agent Profiles", icon: Monitor, hint: "Native agent profiles aur selectors." },
      { id: "oms-automation-health", pageKey: "marketplace-operations", path: ops("capability-health"), label: "Automation Health", icon: Activity, hint: "Har account ki reads / automation ki health." },
      { id: "oms-schedules", pageKey: "marketplace-operations", path: ops("schedules"), label: "Automation Schedule", icon: CalendarClock, hint: "Kaun sa read kab chalta hai." },
      { id: "oms-jobs", pageKey: "marketplace-operations", path: ops("jobs"), label: "Jobs", icon: Clock, hint: "Automation jobs ki history." },
      { id: "oms-marketplace-reports", pageKey: "marketplace-operations", path: ops("reports"), label: "Marketplace Reports", icon: FileSearch, hint: "Marketplace report downloads ki status." },
      { id: "desktop-stations", pageKey: "desktop-stations", path: "/desktop-stations", label: "Desktop Stations", icon: Printer, hint: "AGMONE DESK stations." },
      { id: "otp-dashboard", pageKey: "otp-dashboard", path: "/otp-center", label: "OTP Center", icon: ShieldCheck, hint: "Marketplace OTPs." },
      { id: "otp-accounts", pageKey: "otp-accounts", path: "/otp-center/accounts", label: "Mail Accounts", icon: Mail, hint: "OTP mail accounts." },
      { id: "otp-audit", pageKey: "otp-audit", path: "/otp-center/audit", label: "OTP Audit Logs", icon: FileSearch, hint: "OTP audit logs." },
      { id: "unicommerce", pageKey: "unicommerce", path: "/unicommerce", label: "Uniware", icon: Plug, hint: "Purana Uniware integration: sync, picklist, net stock." },
      { id: "oms-operations-settings", pageKey: "operations-settings", path: "/operations-settings", label: "Operations Settings", icon: Cog, hint: "Feature flags aur system settings." },
      { id: "oms-system-health", pageKey: "system-health", path: "/system-health", label: "System Health", icon: Activity, hint: "System aur marketplace connections ki health." },
    ],
    comingSoon: [],
  },
];

export const OMS_SECTION_IDS = OMS_SECTIONS.map((section) => section.id);

export const getOmsSection = (id) => OMS_SECTIONS.find((section) => section.id === id);

const splitPath = (path) => {
  const { pathname, search } = toLocation(path);
  return { pathname, params: new URLSearchParams(search) };
};

/**
 * How well a menu path matches the current location: -1 = no match, otherwise the number of the
 * path's query params that the location also has. The item with the highest score is the active one,
 * so "/marketplace-operations?tab=payments" wins over "/marketplace-operations".
 */
export function matchScore(itemPath, location) {
  const item = splitPath(itemPath);
  if (!location || item.pathname !== location.pathname) return -1;
  const current = new URLSearchParams(location.search || "");
  let score = 0;
  for (const [key, value] of item.params) {
    if (current.get(key) !== value) return -1;
    score += 1;
  }
  return score;
}

/** The best-matching item of a list for the location, or null. */
export function findActiveItem(items, location) {
  let best = null;
  let bestScore = -1;
  for (const item of items || []) {
    const score = matchScore(item.path, location);
    if (score > bestScore) {
      best = item;
      bestScore = score;
    }
  }
  return best;
}

/** The OMS section and item that best match the location, searched over `sections` (raw or access-filtered). */
export function findOmsMatch(sections, location) {
  let best = null;
  let bestScore = -1;
  for (const section of sections || []) {
    for (const item of section.items || []) {
      const score = matchScore(item.path, location);
      if (score > bestScore) {
        best = { section, item };
        bestScore = score;
      }
    }
  }
  return best;
}

/** Split "/path?query" into a location-like { pathname, search }. */
export function toLocation(path) {
  const [pathname, query = ""] = String(path || "").split("#")[0].split("?");
  return { pathname, search: query ? `?${query}` : "" };
}
